<div class="__info-block__container u-position-relative u-margin-bottom-double" [class.u-bordered-top]="!!label">
    <p *ngIf="label" class="__info-block__title u-position-left u-color-muted u-text-uppercase">
        {{ label }}
    </p>
    <ng-content></ng-content>
</div>
